/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserPreferencesV3 } from '../fn/users/get-user-preferences-v-3';
import { GetUserPreferencesV3$Params } from '../fn/users/get-user-preferences-v-3';
import { patchUserPreferencesV3 } from '../fn/users/patch-user-preferences-v-3';
import { PatchUserPreferencesV3$Params } from '../fn/users/patch-user-preferences-v-3';
import { requestEmailChangeV3 } from '../fn/users/request-email-change-v-3';
import { RequestEmailChangeV3$Params } from '../fn/users/request-email-change-v-3';
import { requestPasswordChangeV3 } from '../fn/users/request-password-change-v-3';
import { RequestPasswordChangeV3$Params } from '../fn/users/request-password-change-v-3';
import { UserPreferencesV3 } from '../models/user-preferences-v-3';
import { verifyEmailChangeV3 } from '../fn/users/verify-email-change-v-3';
import { VerifyEmailChangeV3$Params } from '../fn/users/verify-email-change-v-3';


/**
 * User lifecycle management including creation, modification, role assignments, password management, email changes, and user-specific operations across organizations
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `requestPasswordChangeV3()` */
  static readonly RequestPasswordChangeV3Path = '/users/keycloak/request-password-change';

  /**
   * Request email for password change.
   *
   * Request the email for password change. Keycloak will send an email
   * to the user with a link to change the password.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestPasswordChangeV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestPasswordChangeV3$Response(params?: RequestPasswordChangeV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = requestPasswordChangeV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Request email for password change.
   *
   * Request the email for password change. Keycloak will send an email
   * to the user with a link to change the password.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestPasswordChangeV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestPasswordChangeV3(params?: RequestPasswordChangeV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.requestPasswordChangeV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `requestEmailChangeV3()` */
  static readonly RequestEmailChangeV3Path = '/users/request-email-change';

  /**
   * Change email address and request verification codes.
   *
   * Starts the two-factor email change flow.
   * A verification code will be sent to the current email address,
   * and another one to the new email address. Both codes must later
   * be provided to confirm the change.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestEmailChangeV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestEmailChangeV3$Response(params: RequestEmailChangeV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = requestEmailChangeV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change email address and request verification codes.
   *
   * Starts the two-factor email change flow.
   * A verification code will be sent to the current email address,
   * and another one to the new email address. Both codes must later
   * be provided to confirm the change.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestEmailChangeV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestEmailChangeV3(params: RequestEmailChangeV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.requestEmailChangeV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `verifyEmailChangeV3()` */
  static readonly VerifyEmailChangeV3Path = '/users/verify-email-change';

  /**
   * Verify email change with codes.
   *
   * Completes the two-factor email change flow.
   * Requires the 6-digit code sent to the current email address and
   * the 6-digit code sent to the new email address.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyEmailChangeV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyEmailChangeV3$Response(params: VerifyEmailChangeV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = verifyEmailChangeV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Verify email change with codes.
   *
   * Completes the two-factor email change flow.
   * Requires the 6-digit code sent to the current email address and
   * the 6-digit code sent to the new email address.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyEmailChangeV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyEmailChangeV3(params: VerifyEmailChangeV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.verifyEmailChangeV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserPreferencesV3()` */
  static readonly GetUserPreferencesV3Path = '/users/preferences';

  /**
   * Get the preferences of the logged in user.
   *
   * Returns the personal preferences of the logged in user.
   * Every preference is part of the response. Preferences that are not set,
   * or are no longer valid, are null. The favorite organization site is no longer
   * valid, when the site is no longer assigned to the user or the site is archived
   * or deactivated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserPreferencesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserPreferencesV3$Response(params?: GetUserPreferencesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPreferencesV3>> {
    const obs = getUserPreferencesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the preferences of the logged in user.
   *
   * Returns the personal preferences of the logged in user.
   * Every preference is part of the response. Preferences that are not set,
   * or are no longer valid, are null. The favorite organization site is no longer
   * valid, when the site is no longer assigned to the user or the site is archived
   * or deactivated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserPreferencesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserPreferencesV3(params?: GetUserPreferencesV3$Params, context?: HttpContext): Observable<UserPreferencesV3> {
    const resp = this.getUserPreferencesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserPreferencesV3>): UserPreferencesV3 => r.body)
    );
  }

  /** Path part for operation `patchUserPreferencesV3()` */
  static readonly PatchUserPreferencesV3Path = '/users/preferences';

  /**
   * Change the preferences of the logged in user.
   *
   * Partial update of the personal preferences of the logged in user.
   * Only the given preferences are changed. A preference set to null is removed.
   *
   * favoriteOrganizationSiteKey: The site must be assigned to the user and must not be
   * archived or deactivated. There can be only one favorite organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchUserPreferencesV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchUserPreferencesV3$Response(params: PatchUserPreferencesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPreferencesV3>> {
    const obs = patchUserPreferencesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change the preferences of the logged in user.
   *
   * Partial update of the personal preferences of the logged in user.
   * Only the given preferences are changed. A preference set to null is removed.
   *
   * favoriteOrganizationSiteKey: The site must be assigned to the user and must not be
   * archived or deactivated. There can be only one favorite organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchUserPreferencesV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchUserPreferencesV3(params: PatchUserPreferencesV3$Params, context?: HttpContext): Observable<UserPreferencesV3> {
    const resp = this.patchUserPreferencesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserPreferencesV3>): UserPreferencesV3 => r.body)
    );
  }

}
